import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import Select from 'modules/core/components/Select'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateAssessment } from 'modules/ats/hooks/assessments/useCreateAssessment'

interface Props {
  applicationId: string
  onClose: () => void
}

interface AssessmentFormValues {
  applicationId: string
  gender: string
  accessId: string
}

export const SendDiscAssessmentModal = observer(({ applicationId, onClose }: Props) => {
  const { create } = useCreateAssessment()
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const { values, setValues, isSubmitting, errors, setErrors, handleSubmit } =
    useForm<AssessmentFormValues>({
      defaultValues: {
        gender: '',
        applicationId,
        accessId: accessId,
      },
      onSubmit: async (values) => {
        const result = await create(values)
        const handled = handleResult(result, (errors) => {
          if (errors) {
            setErrors(errors)
          }
        })

        setFlashMessage(handled.success)
        onClose()

        return handled
      },
    })

  const setFlashMessage = (success: boolean) => {
    const type = success ? 'correct' : 'wrong'
    const message = success
      ? i18n.t('ats.candidates.disc_assessment.modal.save.success')
      : i18n.t('ats.candidates.disc_assessment.modal.save.error')

    app.setFlash({
      type: type,
      message: message,
      time: 2000,
    })
  }

  const genderOptions = [
    { label: i18n.t('ats.candidates.disc_assessment.modal.gender.options.male'), value: 'M' },
    {
      label: i18n.t('ats.candidates.disc_assessment.modal.gender.options.female'),
      value: 'F',
    },
  ]

  return (
    <Modal
      illustration="add-user"
      title={i18n.t('ats.candidates.disc_assessment.modal.title')}
      description={i18n.t('ats.candidates.disc_assessment.modal.description')}
      onSubmit={() => handleSubmit()}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={isSubmitting || !values.gender} submit>
            {i18n.t('ats.candidates.disc_assessment.modal.submit')}
          </Button>
        </>
      }
    >
      <Box gap={'s8'}>
        <Select
          mandatory
          none={i18n.t('common.select')}
          label={i18n.t('ats.candidates.disc_assessment.modal.gender.label')}
          options={genderOptions}
          value={values.gender}
          error={errors.gender}
          description={i18n.t('ats.candidates.disc_assessment.modal.gender.warning')}
          onChange={(gender) => setValues({ ...values, gender: gender })}
        />
      </Box>
    </Modal>
  )
})
